export default __webpack_public_path__ + "static/media/user-line.81ff6d68.svg";